import { TourConfig, TourStep } from '../../types';
import { HABITAT_ONBOARDING_ASLEEP_ID } from './ids';
import { VIDEO_DEMO_SRC } from './media';
import { habitatTailSteps, TAIL_STEP_IDS } from './tail';
import { TOUR_TARGETS } from './targets';

const STEP = {
  WELCOME: '1d-welcome',
  VM: 'vm-welcome',
} as const;

/**
 * The habitat has a schedule and we are outside its window — the animals are asleep. Nothing
 * live can be acted on, so this scenario opens on the Activity Feed and hands straight over to
 * the shared tail (meet them, follow them, go somewhere that is awake).
 *
 * The welcome copy quotes the stream window, so it renders nothing until `streamTimes` resolves;
 * an unfilled token collapses the banner rather than showing "We are LIVE  every day".
 */
const steps: TourStep[] = [
  {
    id: STEP.WELCOME,
    analytics: { stepNumber: 1, section: 'Welcome (asleep)' },
    ui: {
      banner: {
        type: 'guide',
        mascot: 'talking',
        speechBubble:
          'Hey there! We are LIVE {{ctx.habitat.streamTimes}} every day from {{ctx.habitat.country}}. ' +
          'This habitat is asleep right now — check when the animals were last seen!',
        buttons: [
          { label: 'Tell me more!', targetStepId: TAIL_STEP_IDS.MEET_LEARN },
          { label: 'Show me the cameras', targetStepId: STEP.VM },
        ],
      },
      spotlight: { target: TOUR_TARGETS.ACTIVITY_FEED, scrollIntoView: true },
    },
  },

  {
    id: STEP.VM,
    analytics: { stepNumber: -1, section: 'Video demo' },
    ui: { modal: { kind: 'video', src: VIDEO_DEMO_SRC, onCloseStepId: STEP.WELCOME } },
  },

  ...habitatTailSteps(),
];

export const habitatAsleepConfig: TourConfig = { id: HABITAT_ONBOARDING_ASLEEP_ID, steps };
export const ASLEEP_FIRST_STEP_ID = STEP.WELCOME;
